<template>
  <el-dialog
    :visible.sync="isShowDialog"
    :close-on-click-modal="false"
    :title="dialogTitle+(key==='f'?'筛选':'表格')+'项设置'"
    center
    :width="dialogWidth ? dialogWidth : '600px'"
  >
    <div class="filter-box">
      <vuedraggable class="content" :list="items" draggable=".allow">
        <div class="filter-item" v-for="(x1, i1) in items" :key="i1" :class="{ allow: modularStart }">
          <div class="sliderColumn" @mouseenter="modularStart = true" @mouseout="modularStart = false"></div>
          <div class="content">{{ x1.label }}</div>
          <el-switch v-model="x1.fChecked" v-if="key==='f'" />
          <el-switch v-model="x1.tChecked" v-if="key==='t'" />
        </div>
      </vuedraggable>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitClick">确 定</el-button>
      <el-button @click="isShowDialog = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import vuedraggable from "vuedraggable";
export default {
  props: ["dialogTitle", "dialogWidth"],
  components: { vuedraggable },
  data() {
    return {
      isShowDialog: false,
      modularStart: false,
      items: [],
      key: 'f',
    };
  },
  methods: {
    open(list, key) {
      this.key = key
      this.items = JSON.parse(JSON.stringify(list.filter(e => !e[key+'Hide']).sort((a, b) => a[key+'Index'] - b[key+'Index'])));
      this.isShowDialog = true;
    },
    submitClick() {
      this.$emit(
        "submit",
        this.items.map((x1) => ({ key: x1.key, status: x1[this.key + 'Checked'] || undefined })),
        this.key,
        () => this.isShowDialog = false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-box {
  height: 428px;
  overflow-y: scroll;
}
.filter-item {
  // cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-right: 20px;
  border: 1px solid #e7e6e6;
  border-radius: 8px;
}
.sliderColumn {
  width: 36px;
  height: 36px;
  cursor: move;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
  &::after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    background: #333;
    box-shadow: 0 -8px 0 #333, 0 8px 0 #333, -8px 0 0 #333, -8px -8px 0 #333, -8px 8px 0 #333;
  }
}
.content {
  flex: 1;
}

/deep/.el-dialog {
  max-height: 600px !important;
  margin-top: 15vh !important;
}
</style>
